import { Component, HostBinding, Inject, Injector, OnInit, PLATFORM_ID, SimpleChanges, ViewEncapsulation, Input, OnChanges } from '@angular/core';
import { CommonHeaderComponent } from '../common-header.component';
import { isPlatformBrowser } from '@angular/common';
import { MediaPictureService } from '../../../services/media-picture.service';

@Component({
  selector: 'header-view-3',
  template: `
    <div class="header-wrapper" id="{{htmlId}}"
        [ngClass]="{'without-sbox': !hasSbox}"
        [style.background]="backgroundStyle">
      
      <div class="header-content vertical-align-{{mainTitleModule?.data?.text_vertical_align}}" 
        [ngClass]="{'default': (imagePosition === 'DEFAULT' || screenType !== 'DESKTOP'), 
          'next-to-shifu': isSboxNextToShifu, 
          'no-full-width': !isSboxNextToShifu}">
        
        <main-title 
          *ngIf="(imagePosition === 'DEFAULT' || screenType !== 'DESKTOP') && hasMainTitle() && !titleInNavBar" 
          [data]="mainTitleModule?.data!" 
          [moduleId]="module.id" 
          [uniqueId]="module.unique_id" 
          defaultColor="white">
        </main-title>
        
        <sbox 
          [ngClass]="{'-eva-3-mt-lg -eva-3-mb-lg': !hasMainTitle() && !hasContentImage(), 'no-full-width': !isSboxNextToShifu}" 
          *ngIf="hasSbox"
          [sboxModule]="sboxModule" 
          [modulePosition]="position" 
          [moduleId]="'HeadingModule'" 
          [uniqueId]="module.unique_id" 
          [nextToShifu]="isSboxNextToShifu">
        </sbox>
        
        <main-title 
          class="main-title-below-sbox" 
          *ngIf="(imagePosition === 'BELOW_SBOX' && screenType === 'DESKTOP') && hasMainTitle() && !titleInNavBar" 
          [data]="mainTitleModule?.data!" 
          [moduleId]="module.id" 
          [uniqueId]="module.unique_id" 
          defaultColor="white">
        </main-title>

        <div class="content-image-container" *ngIf="contentImage">
            <img 
              [src]="contentImage" 
              [alt]="contentImageAlt" 
              loading="lazy"/>
        </div>
      </div>

      <div *ngIf="screenType === 'MOBILE'" id="sboxContainer"></div>
    </div>
  `,
  styleUrls: ['./header-view-3.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeaderView3Component extends CommonHeaderComponent implements OnInit, OnChanges {
  @HostBinding('style.--background-min-height') backgroundMinHeight = '280px';
  @HostBinding('style.--background-max-height') backgroundMaxHeight = 'initial';
  @HostBinding('style.--title-max-width') titleMaxWidth = '100%';
  @HostBinding('style.--mobile-background-min-height') mobileBackgroundMinHeight = 'initial';

  @Input() openLinkInNewTab: boolean = false;

  isSboxNextToShifu: boolean = false;
  isAboveTheFold: boolean = false;
  hasSbox: boolean = false;
  
  imagePosition: string = 'DEFAULT';
  contentImage: string | null = null;
  contentImageAlt: string = '';

  constructor(
    injector: Injector,
    private mediaPictureService: MediaPictureService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    super(injector);
  }

  get backgroundStyle(): string {
    if (!this.backgroundColor) {
      return 'transparent';
    }
    
    if (!this.contentImage) {
      return this.backgroundColor;
    }
    
    const cutHeight = this.screenType === 'MOBILE' ? '40px' : '80px';
    
    return `linear-gradient(to bottom, 
      ${this.backgroundColor} calc(100% - ${cutHeight}), 
      transparent calc(100% - ${cutHeight})
    )`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (isPlatformBrowser(this.platformId)) {
      if (changes.shifuProduct?.currentValue) {
        super.updateData();
        this.initDimensions();
      }
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.initDimensions();
    this.initContentImage();
    this.isAboveTheFold = this.landingModelService.getLandingModel().abTests?.tests?.SboxAboveTheFold?.branch == 'test';
    this.isSboxNextToShifu = this.imagePosition === 'BELOW_SBOX' && this.screenType === 'DESKTOP';
    this.hasSbox = this.sboxModule && (this.screenType != 'MOBILE' || this.flow != 'home');
  }

  initDimensions() {
    const defaultMinWidth = !this.sboxModule ? '230px' :
      !this.hasContentImage() && !this.hasMainTitle() ? 'initial' : '280px';
    this.backgroundMinHeight = this.backgroundModule?.data?.css_options?.['min-height'] || defaultMinWidth;
    this.backgroundMaxHeight = this.backgroundModule?.data?.css_options?.['max-height'] || 'initial';
    this.titleMaxWidth = this.mainTitleModule?.data?.css_options?.['max-width'] || '100%';
    this.mobileBackgroundMinHeight = this.backgroundModule?.data?.css_options?.['mobile-min-height'] || 'initial';
  }

  initContentImage() {
    this.imagePosition = 'DEFAULT';
    const imageUrl = this.screenType === 'MOBILE' && this.backgroundModule?.data?.picture_mobile 
      ? this.backgroundModule.data.picture_mobile 
      : this.backgroundModule?.data?.picture;
    
    if (imageUrl) {
      const imgReqSize = this.screenType === 'MOBILE' ? '656x230' : '1280x240';
      const mediaUrl = this.mediaPictureService.getMediaUrl(imageUrl, imgReqSize);
      this.contentImage = mediaUrl ? mediaUrl + '?op=TRUNCATE&enlarge=false&gravity=ce_0_0&quality=100' : null;
      this.contentImageAlt = this.backgroundModule?.data?.alt || 
                             this.mainTitleModule?.data?.title?.text || 
                             '';
    }
  }

  hasMainTitle(): boolean {
    return !!(this.mainTitleModule?.data &&
      (this.mainTitleModule.data.title?.text
        || this.mainTitleModule.data.pre_title?.text
        || this.mainTitleModule.data.sub_title?.text
      ));
  }

  hasContentImage(): boolean {
    return !!this.contentImage;
  }
}
